var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center mb-8"},[_vm._m(0),_c('div',{staticClass:"flex-grow-1 pl-4"},[_c('div',{staticClass:"font-weight-bold text-3xl"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"doc-img",attrs:{"src":require("@/v2/assets/images/download.png")}})])
}]

export { render, staticRenderFns }